export function checkRelatedRadios(form: HTMLFormElement, element: HTMLInputElement) {
  return Array.from(form.querySelectorAll(`[name="${element.name}"]`)).find(
    (f: HTMLInputElement) => f.checked === true
  );
}

// checkCheckboxGroup searches for a containing element with the class '.checkbox--group' and then see's how many checkbox inputs are checked and returns the nodelist

export function checkCheckboxGroup(form: HTMLFormElement) {
  let checkboxGroup = form.querySelector('.checkbox--group');
  let checked = checkboxGroup.querySelectorAll(`input:checked`);
  return checked;
}
